var _defs, _path, _path2, _circle, _path3, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 600,
    viewBox: "-50 -30 100 60",
    fill: "#c8102e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50-30H50v60H-50z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-50-30H50v60H-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#43b02a",
    stroke: "#fff",
    strokeWidth: 8,
    clipPath: "url(#a)",
    d: "M-55-33v66L55-33v66z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    r: 17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    stroke: "#43b02a",
    strokeWidth: 0.36,
    d: "m0-12.44 1.051 1.82h2.101L2.102-8.8l1.05 1.82H1.051L0-5.16l-1.051-1.82h-2.101l1.05-1.82-1.05-1.82h2.101z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(120)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(240)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.9ffa1d9d2f6fe2561ad77fed0400e236.svg";
export { ForwardRef as ReactComponent };